import { Navigate } from "react-router-dom";
import { getAuth } from "../utils/auth";

export default function NdaRoute({ children }) {
  const auth = getAuth();
  const user = auth?.user;

  if (!auth || !auth.token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.ndaStatus !== "signed") {
    return <Navigate to="/nda" replace />;
  }

  return children;
}